import React from 'react';
import PopUp from '../../../../../muiComponents/PopUp';
import useTranslate from '../../../../../customHooks/useTranslate';
import ZitoneoImage from '../../../../components/Image';

type ImageToDelete = {
    name?: string;
    label?: string;
    src?: string;
    alt?: string;
};

type DeleteImagePopUpProps = {
    open: boolean;
    image?: ImageToDelete;
    onDelete: () => void;
    onCancel: () => void;
};

const DeleteImagePopUp = ({
    open,
    image,
    onDelete,
    onCancel,
}: DeleteImagePopUpProps) => {
    const translate = useTranslate();
    const itemLabel = image?.label || translate('image');
    const itemName = image?.name || itemLabel;

    return (
        <PopUp
            open={open}
            titleText='delete_sure'
            onSave={onDelete}
            onCancel={onCancel}
            saveText='delete'
            saveButonProps={{ className: 'delete-button' }}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                    minWidth: '220px',
                }}
            >
                {image?.src ? (
                    <ZitoneoImage
                        src={image.src}
                        alt={image.alt || itemName}
                        className='zitoneo-logo'
                        useLocalBaseUrl={true}
                        style={{
                            width: '250px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            border: '1px solid var(--border)',
                            overflow: 'hidden',
                        }}
                    />
                ) : null}
            </div>
        </PopUp>
    );
};

export default DeleteImagePopUp;
